/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

//CREATING A DATA SLICE
const affordabilitySlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "affordability",

  //STATE PROPERTIES INCLUDED IN THIS SLICE
  initialState: {
    //Annual
    annualCash: "",
    annualCPFOA: "",
    annualCPFSA: "",
    annualCPFMA: "",
    annualSRS: "",

    //Single
    singleCash: "",
    singleCPFOA: "",
    singleCPFSA: "",
    singleCPFMA: "",
    singleSRS: "",
  },

  //REDUCERS INSIDE EACH SLICE DECLARATION CAN PERFORM ACTION ON EACH DATA STATES
  reducers: {
    updateAffordability: (state, action) => {
      const actionType = action.payload.type;
      const data = action.payload.payload;

      console.log("actionType = " + actionType);
      console.log(data);

      switch (actionType) {
        case "annualCash":
          state.annualCash = data;
          break;

        case "annualCPFOA":
          state.annualCPFOA = data;
          break;

        case "annualCPFSA":
          state.annualCPFSA = data;
          break;

        case "annualCPFMA":
          state.annualCPFMA = data;
          break;

        case "annualSRS":
          state.annualSRS = data;
          break;

        case "singleCash":
          state.singleCash = data;
          break;

        case "singleCPFOA":
          state.singleCPFOA = data;
          break;

        case "singleCPFSA":
          state.singleCPFSA = data;
          break;

        case "singleCPFMA":
          state.singleCPFMA = data;
          break;

        case "singleSRS":
          state.singleSRS = data;
          break;

        default:
          break;
      }
    },
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const { updateAffordability } = affordabilitySlice.actions;

export default affordabilitySlice.reducer;
